module.exports = __webpack_public_path__ + "static/media/img_anli2@2x.c6c3eac2.png";